export default __webpack_public_path__ + "static/media/2008-1.46a407d3.jpg";